import {DateTimeFormatter, LocalDate} from '@js-joda/core';
import type {CapacityConfig} from '@/types/CapacityConfig';

const formatter = DateTimeFormatter.ofPattern('M/d/yyyy');

const getCurrentCapacityYearMonth = (
    capacityConfig : CapacityConfig,
    now = LocalDate.now()
) : keyof CapacityConfig | undefined => {
    return Object.keys(capacityConfig).find(configKey => {
        const configuration = capacityConfig[configKey];
        const fiscalStart = LocalDate.parse(configuration.fiscalstart, formatter);
        const fiscalEnd = LocalDate.parse(configuration.fiscalend, formatter);

        return now.isAfter(fiscalStart) && now.isBefore(fiscalEnd) || now.equals(fiscalStart) || now.equals(fiscalEnd);
    });
};

export default getCurrentCapacityYearMonth;
